import { day } from './factory'
import type { StockCountRow, StockItemRow, StockMovementRow, StockReceiptRow } from '../db'

/**
 * Voorbeeldvoorraad: een paar producten ook in de salon, met inkoopprijs, twee verbruiksartikelen
 * (professionele verpakking) en een handvol mutaties. Bestaat een product-id niet in de catalogus,
 * dan valt het in het overzicht weg.
 */
export const seedStockItems: StockItemRow[] = [
  { id: 'vitality-mask', kind: 'retail', salon: 4, costPriceCents: 2150 },
  { id: 'emerginc-sun-spf-50-tinted', kind: 'retail', salon: 2, costPriceCents: 1890 },
  { id: 'medik8-chrystal-retinal-1', kind: 'retail', salon: 0, costPriceCents: 2400 },
  { id: 'verbruik-reinigingsmelk-500', kind: 'verbruik', name: 'Reinigingsmelk 500 ml (salon)', brand: 'Emerginc', salon: 3, webshop: 2, costPriceCents: 3800 },
  { id: 'verbruik-enzympeeling-250', kind: 'verbruik', name: 'Enzympeeling 250 ml (salon)', brand: 'Emerginc', salon: 1, webshop: 0, costPriceCents: 5200 },
]

const at = (offset: number, time: string) => `${day(offset)}T${time}`

export const seedStockMovements: StockMovementRow[] = [
  { id: 'mut-1', itemId: 'vitality-mask', at: at(-20, '10:05'), reason: 'inkoop', location: 'webshop', qty: 12, by: 'Sarah', ref: 'EM-2026-0412', costPriceCents: 2150 },
  { id: 'mut-2', itemId: 'vitality-mask', at: at(-19, '09:30'), reason: 'overboeken', location: 'webshop', qty: -5, by: 'Sarah', transferId: 'ov-1', costPriceCents: 2150 },
  { id: 'mut-3', itemId: 'vitality-mask', at: at(-19, '09:30'), reason: 'overboeken', location: 'salon', qty: 5, by: 'Sarah', transferId: 'ov-1', costPriceCents: 2150 },
  { id: 'mut-4', itemId: 'vitality-mask', at: at(-6, '15:40'), reason: 'verkoop-salon', location: 'salon', qty: -1, by: 'Sarah', ref: 'S2026-0001', costPriceCents: 2150 },
  { id: 'mut-5', itemId: 'verbruik-reinigingsmelk-500', at: at(-12, '08:50'), reason: 'verbruik', location: 'salon', qty: -1, by: 'Sarah', costPriceCents: 3800 },
  { id: 'mut-6', itemId: 'verbruik-enzympeeling-250', at: at(-4, '08:45'), reason: 'verbruik', location: 'salon', qty: -1, by: 'Sarah', costPriceCents: 5200 },
  {
    id: 'mut-7',
    itemId: 'emerginc-sun-spf-50-tinted',
    at: at(-3, '17:10'),
    reason: 'afschrijven',
    location: 'salon',
    qty: -1,
    by: 'Sarah',
    writeOffCause: 'tester',
    note: 'Open gezet als tester',
    costPriceCents: 1890,
  },
  { id: 'mut-8', itemId: 'medik8-chrystal-retinal-1', at: at(-2, '18:00'), reason: 'telling', location: 'salon', qty: -1, by: 'Sarah', ref: 'telling-1', costPriceCents: 2400 },
]

/** De levering van mut-1, als geboekte inkoopfactuur (zonder bijlage in de demo). */
export const seedStockReceipts: StockReceiptRow[] = [
  {
    id: 'inkoop-1',
    requestId: 'seed-inkoop-1',
    supplier: 'Emerginc',
    invoiceNumber: 'EM-2026-0412',
    invoiceDate: day(-21),
    location: 'webshop',
    lines: [{ itemId: 'vitality-mask', name: 'Vitality Mask', qty: 12, costPriceCents: 2150 }],
    totalCostCents: 25800,
    invoiceTotalCents: 25800,
    file: { name: 'Factuur EM-2026-0412.pdf', size: 184_320, type: 'application/pdf' },
    bookedAt: at(-20, '10:05'),
    by: 'Sarah',
  },
]

/** De salon is twee dagen geleden helemaal geteld; de webshopplek nog nooit (dan staat de telling klaar). */
export const seedStockCounts: StockCountRow[] = [
  {
    id: 'telling-1',
    requestId: 'seed-telling-1',
    location: 'salon',
    at: at(-2, '18:00'),
    by: 'Sarah',
    counted: 5,
    complete: true,
    differences: 1,
    netQty: -1,
    netCostCents: -2400,
  },
]
